import communicate from 'src/api/communicate';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
/**
 * Feature #37689: the employee consent to planned additional work shifts (TLS § 43³).
 *
 * POST /EventConfirmations and POST /EventConfirmations/Withdraw are not in the generated client yet
 * (the dev Swagger predates the controller), so they go through `communicate` the same way the
 * planner's own publish and period confirmation calls do. Swap for the generated client after apigen.
 */
export var EventConfirmationsActions;
(function (EventConfirmationsActions) {
    EventConfirmationsActions["CONFIRM_EVENTS_REQUEST"] = "CONFIRM_EVENTS_REQUEST";
    EventConfirmationsActions["CONFIRM_EVENTS_SUCCESS"] = "CONFIRM_EVENTS_SUCCESS";
    EventConfirmationsActions["CONFIRM_EVENTS_FAIL"] = "CONFIRM_EVENTS_FAIL";
    EventConfirmationsActions["WITHDRAW_EVENT_CONFIRMATIONS_SUCCESS"] = "WITHDRAW_EVENT_CONFIRMATIONS_SUCCESS";
})(EventConfirmationsActions || (EventConfirmationsActions = {}));
function confirmEventsRequest() {
    return { type: EventConfirmationsActions.CONFIRM_EVENTS_REQUEST };
}
function confirmEventsSuccess(payload) {
    return { type: EventConfirmationsActions.CONFIRM_EVENTS_SUCCESS, payload };
}
function confirmEventsFail() {
    return { type: EventConfirmationsActions.CONFIRM_EVENTS_FAIL };
}
function withdrawEventConfirmationsSuccess(payload) {
    return { type: EventConfirmationsActions.WITHDRAW_EVENT_CONFIRMATIONS_SUCCESS, payload };
}
/**
 * Confirms planned additional work shifts. One id confirms a single shift, many ids confirm the
 * whole loaded schedule - the API takes both through the same endpoint and skips shifts that already
 * carry a consent, so retrying is harmless.
 */
export function confirmEvents(input) {
    return (dispatch) => {
        dispatch(confirmEventsRequest());
        return communicate({ url: 'EventConfirmations', method: 'post', data: input })
            .then((response) => {
            const confirmations = response.data.Data || [];
            toastrSuccess(response);
            dispatch(confirmEventsSuccess(confirmations));
            return confirmations;
        })
            .catch((error) => {
            dispatch(confirmEventsFail());
            toastrError(error);
            return Promise.reject(error);
        });
    };
}
/**
 * Withdraws consents already given. Behind its own right, which is normally granted to
 * administrators only - the employee does not take back their own consent alone. The withdrawn
 * confirmation stays in history together with the reason.
 */
export function withdrawEventConfirmations(input) {
    return (dispatch) => {
        dispatch(confirmEventsRequest());
        return communicate({ url: 'EventConfirmations/Withdraw', method: 'post', data: input })
            .then((response) => {
            const withdrawnCount = response.data.Data ?? 0;
            toastrSuccess(response);
            dispatch(withdrawEventConfirmationsSuccess(withdrawnCount));
            return withdrawnCount;
        })
            .catch((error) => {
            dispatch(confirmEventsFail());
            toastrError(error);
            return Promise.reject(error);
        });
    };
}
